<template>
    <FullFillBox
        :pageID="1011"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
    >
        <h4>{{ $t('product_min_stock_manage') }}</h4>
        <hr>
        <div class="row">
            <div class="col-md-6">{{ $t('product_min_stock_total') }} {{ mainData.length }}</div>
            <div class="col-md-6">{{ $t('product_min_stock_bypass') }} {{ mainData.filter(a => a.bypass_flag === 1).length }}</div>
        </div>
        <hr>
        <ProductFilterMultiSelect
            :mainData="mainData"
            ref="filterBar"
            v-if="mainData"
            @getFilteredData="(data) => {
                    this.tabulator.setData(data)
                    this.tabulator.redraw(true)
                }"
        />
        <hr>
        <div ref="tabulatorTableUse"></div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import ProductFilterMultiSelect from "@/components/ProductFilterMultiSelect.vue";

export default {
    name: "ProductMinStockLvView",
    components: {
        ProductFilterMultiSelect,
        FullFillBox,
        Multiselect,
    },
    data(){
        return{
            permissionDetails: {},
            showEditButton: false,
            brandList: [],
            getBrand: [],
            categoryList: [],
            getCategory: [],

            mainData: [],
            tabulatorTablesList: [],
        }
    },
    methods: {
        filterSelected(){
            let nowTableData = this.mainData
            if(this.getCategory.length > 0 && this.getBrand.length > 0){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name) || this.getBrand.includes(a.brand_name))
            }
            if(this.getCategory.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name))
            }
            if(this.getBrand.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getBrand.includes(a.brand_name))
            }
            this.tabulator.setData(nowTableData)
            this.tabulator.redraw()
        },
        async getFilterData(){
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        // 1 -> Category, 2 -> Brand
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                    }
                })
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/inventory/min-stock/')
                .then(response => {
                    if(response.data.status === 80){
                        this.mainData = response.data.details
                        this.tabulator.setData(this.mainData)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('product_min_stock')

        this.getFilterData()
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', maxWidth: 20, responsive: 0},
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, hozAlign: "center", minWidth: 200,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 200,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 1, hozAlign: "center",
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Min Stock CTN', field: 'min_stock_ctn', sorter: 'number', resizable: false,
                    responsive: 0, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                    formatter: (cell) => {
                        cell.getElement().style.background = '#77ff77'
                        return `<span>${cell.getValue()}</span>`
                    },
                    cellClick: (e, row, formatterParams) => {
                        if(this.showEditButton){
                            this.$swal.fire({
                                title: this.$t('product_min_stock_update_min_stock'),
                                input: 'text',
                                inputValue: row.getData().min_stock_ctn,
                                inputAttributes: {
                                    autocapitalize: 'off',
                                },
                                showCancelButton: true,
                                confirmButtonText: this.$t('common_update'),
                                showLoaderOnConfirm: true,
                                preConfirm: (getRemarks) => {
                                    return this.$mainApi.put(`api/inventory/min-stock/`, {
                                        "pid": row.getData().id,
                                        "min_stock": getRemarks,
                                    })
                                        .then(response => {
                                            return response.data
                                        })
                                        .catch(error => {
                                            this.$swal.showValidationMessage(
                                                `Request failed: ${error}`
                                            )
                                        })
                                },
                                allowOutsideClick: () => !this.$swal.isLoading()
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    if(result.value.status === 80){
                                        this.$swal.fire({
                                            title: this.$t('common_success'),
                                            icon: 'success'
                                        })
                                        this.getBackendData()
                                    }else{
                                        this.$swal.fire({
                                            title: result.value.errors,
                                            text: JSON.stringify(result.value.details),
                                            icon: 'error'
                                        })
                                    }
                                }
                            })
                        }else{
                            this.$toast.error(this.$t('error_no_permission'))
                        }
                    },
                },
                {
                    title: 'Min Stock Qty', field: 'min_stock_qty', sorter: 'number', resizable: false,
                    responsive: 5, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Now Qty', field: 'total_qty', sorter: 'number', resizable: false,
                    responsive: 5, widthGrow: 1.5, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_inner_packing'), field: 'inner packing', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Outer Packing', field: 'outer packing', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 2, hozAlign: "center",
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Size', field: 'size', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'product_remarks', sorter: 'string', resizable: false,
                    responsive: 5, widthGrow: 2, hozAlign: "center", visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {field: 'show_name', visible: false,},
                {field: 'createDate', visible: false,},
                {field: 'mslv_id', visible: false,},
                {field: 'mslv_remarks', visible: false,},
                {field: 'ip', visible: false,},
                {field: 'bypass_flag', responsive: 0, maxWidth: 20,
                    hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu,
                    formatter: (cell) => {
                        if(cell.getValue() === 0){
                            // 0 is not bypassed
                            return "<i class='bi bi-x-square-fill' style='color: red'></i>"
                        }else{
                            // 1 is bypassed
                            return "<i class='bi bi-x-square-fill' style='color: green'></i>"
                        }
                    },
                    cellClick:
                        (e, row, formatterParams) => {
                            if(this.showEditButton){
                                if(row.getData().bypass_flag === 0){
                                    // No Bypass, add new Bypass
                                    this.$swal.fire({
                                        title: this.$t('product_min_stock_create_remarks'),
                                        input: 'text',
                                        inputAttributes: {
                                            autocapitalize: 'off'
                                        },
                                        showCancelButton: true,
                                        confirmButtonText: this.$t('product_min_stock_create_bypass'),
                                        showLoaderOnConfirm: true,
                                        preConfirm: (getRemarks) => {
                                            return this.$mainApi.post(`api/inventory/min-stock/`, {
                                                "pid": row.getData().id,
                                                "remarks": getRemarks,
                                            })
                                                .then(response => {
                                                    return response.data
                                                })
                                                .catch(error => {
                                                    this.$swal.showValidationMessage(
                                                        `Request failed: ${error}`
                                                    )
                                                })
                                        },
                                        allowOutsideClick: () => !this.$swal.isLoading()
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            if(result.value.status === 80){
                                                this.$swal.fire({
                                                    title: this.$t('common_success'),
                                                    icon: 'success'
                                                })
                                                this.getBackendData()
                                            }else{
                                                this.$swal.fire({
                                                    title: result.value.errors,
                                                    text: JSON.stringify(result.value.details),
                                                    icon: 'error'
                                                })
                                            }
                                        }
                                    })
                                }else if(row.getData().bypass_flag === 1){
                                    // Bypassed
                                    this.$swal.fire({
                                        html: '<h4>'+this.$t('common_confirm_action_bypass')+'</h4>' ,
                                        icon: 'info'
                                    }).then(async result => {
                                        if (result.isConfirmed) {
                                            await this.$mainApi.delete(`api/inventory/min-stock?id=${row.getData().mslv_id}`)
                                                .then(response => {
                                                    if(response.data.status === 80){
                                                        this.$toast.success(this.$t('common_success'))
                                                        this.getBackendData()
                                                    }else{
                                                        this.$toast.error(response.data.errors)
                                                    }
                                                })
                                        }
                                    })
                                }
                            }else{
                                this.$toast.error(this.$t('error_no_permission'))
                            }
                        }
                },
                {
                    formatter: (cell) => {
                        if(cell.getRow().getData().bypass_flag === 0){
                            // pass
                        }else{
                            return "<i class='bi bi-plus-circle-fill'></i>"
                        }
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu, headerClick: this.closeAllSubTable,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick:
                        (e, row, formatterParams) => {
                            if(row.getData().bypass_flag === 1){
                                const id = row.getData().id;
                                let parent = document.getElementById("subParent-" + id + "")

                                if (parent.style.display === "none") {
                                    parent.style.display = 'block'

                                    let mainContainer = document.createElement("div")
                                    parent.appendChild(mainContainer);
                                    mainContainer.setAttribute('id', 'mainContainer' + id)
                                    mainContainer.style.textAlign = "center"

                                    let loading = document.createElement("div")
                                    mainContainer.appendChild(loading);
                                    loading.setAttribute('class', 'spinner-grow')
                                    loading.setAttribute('role', 'status')

                                    let tableEl = document.createElement("div");
                                    mainContainer.appendChild(tableEl);
                                    tableEl.style.border = "1px solid #333";
                                    tableEl.style.margin = "auto";
                                    tableEl.setAttribute('id', "subTableID-" + id + "");
                                    tableEl.setAttribute('class', "subTable");

                                    loading.remove()

                                    this.subTable = new Tabulator(tableEl, {
                                        placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                        maxHeight: '20vh',
                                        responsiveLayout: 'collapse',
                                        layout: "fitColumns",
                                        movableColumns: true,
                                        movableRows: false,
                                        data: [
                                            {
                                                "show_name": row.getData().show_name,
                                                "createDate": row.getData().createDate,
                                                "mslv_remarks": row.getData().mslv_remarks,
                                                "ip": row.getData().ip,
                                            }
                                        ],
                                        columns: [
                                            {
                                                title: 'User', field: 'show_name', sorter: 'string', resizable: false,
                                                responsive: 1, widthGrow: 1,
                                            },
                                            {
                                                title: 'create Date', field: 'createDate', sorter: 'string', resizable: false,
                                                responsive: 1, widthGrow: 2,
                                            },
                                            {
                                                title: this.$t('table_remarks'), field: 'mslv_remarks', sorter: 'string', resizable: false,
                                                responsive: 1, widthGrow: 2,
                                            },
                                            {
                                                title: 'ip', field: 'ip', sorter: 'string', resizable: false,
                                                responsive: 1, widthGrow: 1,
                                            },
                                        ],
                                    })

                                    this.tabulatorTablesList.push(
                                        {
                                            "id": id,
                                            "table": this.subTable
                                        }
                                    )
                                }else{
                                    this.tabulatorTablesList = this.tabulatorTablesList.filter(a => a.id !== parseInt(id))
                                    document.getElementById("mainContainer" + id).remove()
                                    parent.style.display='none'
                                }
                            }
                        }
                },
            ],
            reactiveData: true, //enable data reactivity
            height: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            rowFormatter: (row, e) => {
                //create and style holder elements
                let holderEl = document.createElement("div");

                const subTable = row.getData().id;

                holderEl.style.display = "none";
                holderEl.style.boxSizing = "border-box";
                holderEl.style.padding = "10px 10px 10px 10px";
                holderEl.style.borderTop = "1px solid #333";
                holderEl.style.borderBotom = "1px solid #333";
                holderEl.style.width = "90vw";
                holderEl.style.background = "#ffffff";

                holderEl.setAttribute('id', "subParent-" + subTable + "");
                holderEl.setAttribute('class', "subParent");

                row.getElement().appendChild(holderEl);
            }
        })
        this.getBackendData()

        // Only One Listener, loop though subTable
        addEventListener('resize', () => {
            let a = document.getElementsByClassName('subTable')
            for (let i = 0; i < a.length; i++) {
                let getID = (a[i].id).split('-')[1]
                try {
                    let this_table = this.tabulatorTablesList.filter(a => a.id === parseInt(getID))[0]['table']
                    this_table.redraw()
                } catch (e) {
                    // pass
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
